import{hashFunction as o,hashAbiItem as t}from"./hashFunction.js";const n=n=>"string"==typeof n?o(n):t(n);export{n as getEventSelector};
